import { useEffect, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { useAuth } from '@saltus/auth';
import { makeStyles } from '@material-ui/core/styles';
import debug from '../../services/debug';
import handleSignOut from '../../services/handleSignOut';
import isInGroup from '../../services/util/isInGroup';


// TODO(raffclar): Use an alert component
const useStyles = makeStyles(() => ({
  countdownBanner: {
    backgroundColor: '#fff3cd',
    color: '#856404',
    padding: '12px',
    textAlign: 'center',
  },
}));

const DEFAULT_TIMEOUT =
  (parseInt(import.meta.env.VITE_APP_TIMEOUT, 10) || 900) * 1000; // Convert an existing timeout in seconds to milliseconds
const DEFAULT_TIMEOUT_PROMPT =
  (parseInt(import.meta.env.VITE_APP_TIMEOUT_PROMPT, 10) || 300) * 1000; // Convert an existing timeout in seconds to milliseconds
const ADVISER_TIMEOUT =
  (parseInt(import.meta.env.VITE_APP_TIMEOUT_ADVISER, 10) || 2100) * 1000;
const ADVISER_TIMEOUT_PROMPT =
  (parseInt(import.meta.env.VITE_APP_TIMEOUT_ADVISER_PROMPT, 10) || 600) * 1000;

const getTimeoutAndPromptByRole = (user: object | null) => {
  if (isInGroup(user, 'Adviser')) {
    return {
      timeout: ADVISER_TIMEOUT,
      prompt: ADVISER_TIMEOUT_PROMPT
    };
  }
  return {
    timeout: DEFAULT_TIMEOUT,
    prompt: DEFAULT_TIMEOUT_PROMPT
  };
};

function AutomaticLogout() {
  const { user } = useAuth();
  const classes = useStyles();
  const { timeout, prompt }= getTimeoutAndPromptByRole(user);
  const [remainingTime, setRemainingTime] = useState<number | null>(null);
  const onActive = () => {
    debug('User is active');
    setRemainingTime(null);
  };

  const onIdle = async () => {
    debug('User is idle, signing out');
    await handleSignOut();
  };

  const formatTime = (ms: number): string => {
    const minutes = Math.floor(ms / 60000);
    const seconds = Math.floor((ms % 60000) / 1000);
    return `${minutes}:${seconds.toString().padStart(2, '0')}`;
  };

  // eslint-disable-next-line @typescript-eslint/unbound-method
  const { pause, getRemainingTime } = useIdleTimer({
    onActive,
    onIdle,
    timeout,
    throttle: 500,
  });

  useEffect(() => {
    const checkRemainingTime = () => {
      const remaining = getRemainingTime();
      if (remaining <= prompt) {
        setRemainingTime(remaining);
      } else {
        setRemainingTime(null);
      }
    };

    // Check the remaining time every second when there's less than 10 minutes left
    const interval = setInterval(checkRemainingTime, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [getRemainingTime, prompt]);

  useEffect(() => {
    if (window.ReactNativeWebView || !import.meta.env.PROD) {
      debug('Pausing idle timer for mobile app/development');

      pause();
    }
  }, [pause]);

  return (
    <>
      {remainingTime !== null && remainingTime > 0 && (
        <div className={classes.countdownBanner}>
          Your session will expire in {formatTime(remainingTime)}. Move your
          mouse or press any key to stay logged in.
        </div>
      )}
    </>
  );
}

export default AutomaticLogout;
